var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('file-pond',{ref:"file",attrs:{"name":"file","allowRevert":"false","files":_vm.files,"label-idle":"Arraste aqui ou escolher arquivo","server":{
    url:
      _vm.url +
      'pedidos/' + _vm.order + '/arquivos',
    process: {
      headers: {
        'x-auth-token': this.token,
      },
      onload: (response) => {
        this.response = JSON.parse(response);

        if (this.response.status && this.response.status == 'success') {
          this.$parent.$parent.$parent.$parent.file.add.modal = false;
          this.$parent.$parent.$parent.$parent.getPedido();
        } else if (this.response.status && this.response.status == 'error') {
          this.$toast.error(this.response.message);
        } else {
          this.$parent.$parent.$parent.$parent.getPedido();
        }
      }
    },
  }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }